import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ContractVersionChange from 'modules/contracts/components/ContractHistory/ContractVersionUpdate'
import type { Update } from 'modules/contracts/components/ContractHistory/ContractVersionUpdate'

interface Props {
  contractVersionId: number
  updates: Update[]
}

const ContractVersionUpdates = ({ contractVersionId, updates }: Props) => (
  <Box paddingTop="s8">
    <Box
      component="ul"
      gap="s4"
      paddingX="s24"
      paddingTop="s16"
      border={updates.length > 0 && { top: { width: 's2', style: 'solid', color: 'grey400' } }}
    >
      {updates.map((update, index) => (
        <ContractVersionChange
          update={update}
          key={`${update.key}-${contractVersionId}-${index}`}
        />
      ))}
    </Box>
  </Box>
)

export default observer(ContractVersionUpdates)
